<!--
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 简单表格
 * @Date: 2021-07-26 15:23:40
 * @LastEditTime: 2022-01-18 20:05:07
-->
<template>
  <div
    class="van-table"
    :style="{ width: config.width || '100%', height: config.height || 'auto' }"
  >
    <table
      :class="{ [config.tableClass]: config.tableClass }"
      :style="{
        width: config.width || '100%',
        height: config.height || 'auto',
      }"
      :cellpadding="config.cellpadding||1"
      :cellspacing="config.cellspacing||2"
      :border="config.border||0"
    >
      <thead
        v-if="config.showHeader"
        :class="{ [config.tHeadClass]: config.tHeadClass }"
      >
        <tr>
          <td v-for="[key, value] in theadMap" :key="key">
            {{ value }}
          </td>
        </tr>
      </thead>
      <tbody
        v-if="list.length > 0"
        :class="{ [config.tbodyClass]: config.tbodyClass }"
      >
        <tr
          v-for="(item, index) in list"
          :key="item"
          :class="{
            'van-table-stripe': index % 2 === 1,
            'vant-tr-hover': config.highlightCurrentRow,
          }"
        >
          <td
            v-for="[key, value] in theadMap"
            :key="value"
            :style="
              item[key] &&
                item[key].toString().replace(' $', '') > 0 &&
                key === 'pay'
                ? 'color:#02b902'
                : item[key] &&
                  item[key].toString().replace(' $', '') < 0 &&
                  key === 'pay'
                  ? 'color:#f52829'
                  : ''
            "
          >
            <span v-if="item[key]==='debit'">account balance deduction</span>
            <span v-else-if="item[key]==='refund'">order refund</span>
            <span v-else-if="item[key]==='reward_debit'">reward deduction</span>
            <span v-else-if="item[key]==='manual cost'||item[key]==='manual reward cost'">order</span>
            <span v-else>{{ item[key] || '--' }}</span>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="theadMap.size">
            <NullData />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { reactive, toRefs, watch } from 'vue'
export default {
  props: {
    // 表头
    thead: {
      required: true,
      type: Array,
      default: () => [],
    },
    // 表数据
    data: {
      required: true,
      type: Array,
      default: () => [],
    },
    config: {
      required: true,
      type: Object,
      default: () => ({
        height: 'auto', // 表格高度
        width: '100%', // 表格宽度
        stripe: true, // 斑马线
        showHeader: true, // 是否展示表头
        highlightCurrentRow: true, // 是否悬浮高亮
        tableClass: '', // table 自定义类名
        tbodyClass: '', // tbody自定义类名
        tHeadClass: '', // thead自定义类名
      }),
    },
    loadling: {
      type: Boolean,
      default: false,
    },
    addKeyword:{
      type: Boolean,
      default: false,
    }
  },
  setup(props) {
    if (Array.isArray(props.thead) && !props.thead.length) {
      console.error('必须传入表头的数据')
    }

    // 表头数据;
    const theadMap = new Map()
    if (Array.isArray(props.thead) && props.thead.length > 0) {
      props.thead.forEach((item) => {
        if (Object.keys(item).length > 0) {
          for (var key in item) {
            theadMap.set(key, item[key])
          }
        } else {
          console.error('请传入正确的表头数据')
        }
      })
    }

    // table列表数据;
    const newData = reactive({
      list: (Array.isArray(props.data) && props.data) || [],
      loadling: props.loadling,
    })
    watch(
      () => props.data,
      (newVal) => {
        newData.list = Array.isArray(newVal) && newVal
      },
      { immediate: true }
    )
    watch(
      () => props.loadling,
      (newVal) => {
        newData.loadling = newVal
      },
      { immediate: true }
    )

    return {
      theadMap,
      ...toRefs(newData)
    }
  },
}
</script>

<style lang="scss" scoped>
table,
tbody,
tfoot,
thead,
tr,
th,
td { margin: 0; padding: 0; border: 0; vertical-align: baseline; }

.van-table {
  table {
    overflow: auto;
  }

  thead {
    background: #efeeff;
    color: #1e183f;
    font-size: 13px;
  }

  tr.van-table-stripe {
    background: $gray;
  }

  tr {
    display: flex;
    align-items: center;

    td {
      padding: 10px 0;
      text-align: center;
      flex: 1;

      :deep(.null-box) {
        margin-top: 0;
      }
    }
  }

  .loading {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
  }

  .van-checkbox {
    justify-content: center;
  }
}
</style>
